/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:59
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:40
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import {
  SET_BILLING_TERMS, COMPLETE_BILLING_LIST, CLEAR_BILLING_LIST,
} from './mutation-types';

export default {
  [SET_BILLING_TERMS](state, payload) {
    const _state = state;
    _state.billingList.terms = payload.terms;
  },
  [COMPLETE_BILLING_LIST](state, payload) {
    const _state = state;
    _state.billingList.data = payload.list;
    _state.billingList.count = payload.count;
    _state.billingList.summary = payload.summary;
  },
  [CLEAR_BILLING_LIST](state) {
    const _state = state;
    _state.billingList.data = [];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Billing/mutations.js